import styled from "styled-components";
import logoTMmobile from "../../assets/logo-TM-mobile.svg";

export const Container = styled.main`
	width: 50%;
	height: 100vh;
	padding: 2.5rem;

	@media only screen and (max-width: 800px) {
		width: 100%;
		max-width: 23rem;
		padding: 1rem 0;
		height: auto;
	}
`;

export const Header = styled.div`
	display: grid;
	grid-template-columns: 1fr minmax(1rem, auto);
	gap: 0.5rem;

	@media only screen and (max-width: 380px) {
		gap: 0.3rem;
	}
`;

export const BoxHeader = styled.div`
	display: inline-grid;
	gap: 8px;
`;

export const Logo = styled.div`
	height: 4rem;
	background: url(${logoTMmobile}) left no-repeat;

	@media only screen and (max-width: 800px) {
		background-size: 8.4rem;
		height: 2rem;
	}

	@media only screen and (max-width: 380px) {
		background-size: 8rem;
	}
`;

export const Title = styled.div`
	color: var(--neutral-smoothest, #fff);
	font-family: var(--font-family-metropolis-regular);
	font-size: 20px;
	font-style: normal;
	font-weight: 600;
	line-height: 140%;

	@media only screen and (max-width: 800px) {
		font-size: 12px;
	}
`;

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	gap: 17px;
`;

export const Label = styled.label`
	display: none;

	@media only screen and (max-width: 800px) {
		display: inline-block;
		color: var(--neutral-smoothest, #fff);
		font-family: var(--font-family-metropolis-regular);
		font-size: 12px;
		font-style: normal;
		font-weight: 600;
		line-height: 170%;
	}
`;

export const Wrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 16px;

	padding: 16px 0;
	border-bottom: 1px solid rgba(255, 255, 255, 0.08);

	svg {
		min-width: 24px;
		color: #01e59b;
	}
`;

export const Description = styled.p`
	color: var(--neutral-smooth, #caced4);
	font-family: var(--font-family-metropolis-regular);
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 160%;
`;

export const Pros = styled.div`
	color: var(--neutral-smoothest, #fff);
	font-family: var(--font-family-metropolis-regular);
	font-size: 12px;
	font-style: normal;
	font-weight: 600;
	line-height: 170%;
`;

export const FooterPlan = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(10rem, auto));
	overflow-x: auto;
	height: 79vh;
	gap: 8px;

	@media only screen and (max-width: 800px) {
		grid-template-columns: repeat(${({ size }) => size}, minmax(18.75rem, auto));
		gap: 10px;
		height: -webkit-fit-content;
		overflow-y: hidden;
	}
`;

export const FooterMicroService = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(9.75rem, auto));
	overflow: auto;
	height: 79vh;
	gap: 1rem;
	justify-items: center;

	@media only screen and (max-width: 800px) {
		grid-template-columns: repeat(${({ size }) => size}, minmax(10rem, auto));
		gap: 10px;
		height: 100%;
	}
`;
